// Must be kept in sync with value in _retail-spa-sidebar-layout.scss
export const largeScreenQuery = window.matchMedia('(min-width: 1100px)');
